import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { UpdateAndRecalculatedSalePatternsWithProductCommand, UpdateAndRecalculatedSalePatternsWithProductCommandHandlerBase, UpdateAndRecalculatedSalePatternsWithProductCommandResult } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(UpdateAndRecalculatedSalePatternsWithProductCommand)
@Injectable({ providedIn: 'root'})
export class UpdateAndRecalculatedSalePatternsWithProductCommandHandler {
    private commandHandler: UpdateAndRecalculatedSalePatternsWithProductCommandHandlerBase;

    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new UpdateAndRecalculatedSalePatternsWithProductCommandHandlerBase(http);
    }

    public async handleAsync(params: UpdateAndRecalculatedSalePatternsWithProductCommand): Promise<UpdateAndRecalculatedSalePatternsWithProductCommandResult[]> {
        return await this.commandHandler.handleAsync(params);
    }
}